export default __webpack_public_path__ + "static/media/G0000.b50f9e7e.png";